import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = process.env.REACT_APP_SITE_URL;

const setMeta = (attr, key, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const SEO = ({ title, description, image, noindex = false, robots }) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const full = title ? (title.includes("|") ? title : `${title} | Home Haven`) : "Sviluppo e Valorizzazione Immobiliare | Home Haven";
    document.title = full;
    const clean = pathname.replace(/\/+$/, "") || "/";
    const url = `${SITE}${clean === "/" ? "/" : clean}`;
    const img = image || `${SITE}/og-image.png`;
    setMeta("name", "description", description);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
    setMeta("name", "robots", robots || (noindex ? "noindex, nofollow, noarchive" : "index, follow"));
    let link = document.head.querySelector('link[rel="canonical"]');
    if (noindex || robots) { link?.remove(); return; }
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", url);
  }, [title, description, image, pathname, noindex, robots]);
  return null;
};
